import { c as _c } from "react/compiler-runtime";
import { ZERO } from '@morpho-org/dapp-core';
import { useMemo } from 'react';
interface EarnPositionRow {
  assets: {
    assetsUsd?: bigint | null;
  };
}
interface BorrowPositionRow {
  collateral: {
    value?: number | null;
  };
  borrow: {
    value?: number | null;
  };
}
interface EarnPositionsTotalsResult {
  hasNoPositions: boolean;
  totalDepositsValue: bigint;
}
interface BorrowPositionsTotalsResult {
  hasNoPositions: boolean;
  totalBorrowValue: number;
  totalCollateralValue: number;
}
export const useEarnPositionsTotals = (earnPositionsTableRows, isNotFound) => {
  const $ = _c(8);
  const hasNoPositions = isNotFound || earnPositionsTableRows.length === 0;
  let t0;
  if ($[0] !== earnPositionsTableRows) {
    t0 = earnPositionsTableRows.reduce(_temp, ZERO);
    $[0] = earnPositionsTableRows;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const totalDepositsValue = t0;
  let t1;
  if ($[2] !== hasNoPositions || $[3] !== totalDepositsValue) {
    t1 = {
      hasNoPositions,
      totalDepositsValue
    };
    $[2] = hasNoPositions;
    $[3] = totalDepositsValue;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    hasNoPositions: hasNoPositions_0,
    totalDepositsValue: totalDepositsValue_0
  } = t1;
  let t2;
  if ($[5] !== hasNoPositions_0 || $[6] !== totalDepositsValue_0) {
    t2 = {
      hasNoPositions: hasNoPositions_0,
      totalDepositsValue: totalDepositsValue_0
    };
    $[5] = hasNoPositions_0;
    $[6] = totalDepositsValue_0;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export const useBorrowPositionsTotals = borrowPositionsRows => {
  const $ = _c(10);
  let t0;
  bb0: {
    if (borrowPositionsRows.length === 0) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
          hasNoPositions: true,
          totalBorrowValue: 0,
          totalCollateralValue: 0
        };
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    let t1;
    if ($[1] !== borrowPositionsRows) {
      t1 = borrowPositionsRows.reduce(_temp2, {
        totalBorrowValue: 0,
        totalCollateralValue: 0
      });
      $[1] = borrowPositionsRows;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    const {
      totalBorrowValue,
      totalCollateralValue
    } = t1;
    let t2;
    if ($[3] !== totalBorrowValue || $[4] !== totalCollateralValue) {
      t2 = {
        hasNoPositions: false,
        totalBorrowValue,
        totalCollateralValue
      };
      $[3] = totalBorrowValue;
      $[4] = totalCollateralValue;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t0 = t2;
  }
  const {
    hasNoPositions,
    totalBorrowValue: totalBorrowValue_0,
    totalCollateralValue: totalCollateralValue_0
  } = t0;
  let t1;
  if ($[6] !== hasNoPositions || $[7] !== totalBorrowValue_0 || $[8] !== totalCollateralValue_0) {
    t1 = {
      hasNoPositions,
      totalBorrowValue: totalBorrowValue_0,
      totalCollateralValue: totalCollateralValue_0
    };
    $[6] = hasNoPositions;
    $[7] = totalBorrowValue_0;
    $[8] = totalCollateralValue_0;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};
function _temp(accumulator, row) {
  return accumulator + (row.assets.assetsUsd ?? ZERO);
}
function _temp2(acc, row) {
  acc.totalBorrowValue = acc.totalBorrowValue + (row.borrow.value ?? 0);
  acc.totalCollateralValue = acc.totalCollateralValue + (row.collateral.value ?? 0);
  return acc;
}